import { Component, HostBinding, Input } from '@angular/core'
import { LabelType } from '@widgets/label/label.component'

@Component({
  selector: 'bdg-info-label',
  templateUrl: './info-label.component.html',
  styleUrls: ['./info-label.component.scss'],
})
export class InfoLabelComponent {
  @HostBinding('style.display')
  private display = 'flex'

  @Input() label: string

  @Input() labelType: LabelType = 'body-2'

  @Input() labelStyle: string

  @Input() contentType: LabelType = 'body-1'

  @Input() direction: 'horizontal' | 'vertical' = 'vertical'

  @Input() placeholder = '-'

  @Input() tooltip: string

  @Input() truncate = true

  hint: string

  get flexDirection(): string {
    return this.direction === 'vertical' ? 'flex-column' : 'flex-row'
  }

  get classLabel() {
    return `mat-${this.labelType}`
  }

  get classContent() {
    return `mat-${this.contentType}`
  }

  onMouseEnter(hintSpan: HTMLSpanElement) {
    this.hint = hintSpan.offsetWidth < hintSpan.scrollWidth ? hintSpan.innerText : ''
  }
}
